import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ConsentContext = createContext(null);
const POLICY_VERSION = "1.0";
const STORAGE_KEY = "rdi_consent";

const load = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"); } catch { return null; }
};

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(load());
  const [centerOpen, setCenterOpen] = useState(false);

  const persist = useCallback((choices) => {
    const record = { choices, policy_version: POLICY_VERSION, date: new Date().toISOString() };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(record)); } catch {}
    setConsent(record);
    api.post("/consent", { choices, policy_version: POLICY_VERSION }).catch(() => {});
  }, []);

  const acceptAll = () => persist({ necessary: true, functional: true });
  const refuseAll = () => persist({ necessary: true, functional: false });
  const savePrefs = (functional) => persist({ necessary: true, functional: !!functional });

  const functionalAllowed = !!consent?.choices?.functional;
  const hasChoice = !!consent;

  return (
    <ConsentContext.Provider value={{
      consent, hasChoice, functionalAllowed, POLICY_VERSION,
      acceptAll, refuseAll, savePrefs,
      centerOpen, openCenter: () => setCenterOpen(true), closeCenter: () => setCenterOpen(false),
    }}>
      {children}
    </ConsentContext.Provider>
  );
}

export const useConsent = () => {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error("useConsent must be used within ConsentProvider");
  return ctx;
};
